// extracted by mini-css-extract-plugin
module.exports = {"container":"CardError_container__3MDJZ","link":"CardError_link__3JUHJ"};